import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'
import CustomRadioBoxes from 'Pods/Shared/Checkbox/CustomRadioBoxes'

import CgiModelDetails from './CgiModelDetails'
import PrintableModelDetails from './PrintableModelDetails'

function TechnicalDetailsSection({
  handleDetailChange,
  onTypeChange,
  type,
  cgTechDetails,
  printableTechDetails,
  cadProductTypeEnabled = false,
}) {
  const types = [
    { value: 'cg', label: 'CGI model' },
    { value: 'printable', label: '3D print model' },
    { value: 'cad', label: 'CAD model' },
  ].filter(({ value }) => value !== 'cad' || cadProductTypeEnabled || type === 'cad')

  return (
    <div className="section__tech-details">
      <div className="modal-section__title">
        Technical details
        <Tooltip
          id="technical-details-tooltip"
          content={I18n.translate('tooltips.publisher.technical_details')}
          tooltipClassName="tooltip--big u-text-center"
          className="u-inline-block"
        >
          <Icon type={['fas', 'info-circle']} color="grey" className="ml-5" />
        </Tooltip>
      </div>

      <div className="technical-details__type-selector">
        <CustomRadioBoxes
          options={types}
          selectedValue={type}
          onChange={onTypeChange}
        />
      </div>

      {type === 'cg' && (
        <CgiModelDetails
          handleDetailChange={handleDetailChange}
          cgTechDetails={cgTechDetails}
        />
      )}

      {type === 'printable' && (
        <PrintableModelDetails
          handleDetailChange={handleDetailChange}
          printableTechDetails={printableTechDetails}
        />
      )}
    </div>
  )
}

TechnicalDetailsSection.propTypes = {
  handleDetailChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  cgTechDetails: PropTypes.object.isRequired,
  printableTechDetails: PropTypes.object.isRequired,
  cadProductTypeEnabled: PropTypes.bool,
}

export default TechnicalDetailsSection
